<script context="module">
  import PageHead from "./../Components/PageHead.svelte";
  import Dollar from "../Components/Dollar.svelte";
  import FeeItem from "../Components/FeeItem.svelte";
  import Insurance from "./Partials/Insurance.svelte";
  import Affidavit from "./Partials/Affidavit.svelte";
  import Address from "../Shared/Address.svelte";
  import Alerts from "../Shared/Alerts.svelte";
  import Breadcrumb from "./Partials/Breadcrumb.svelte";
  export { default as layout } from "../Shared/Layout.svelte";
</script>

<script>
  import Time from "svelte-time";
  import { useForm, inertia } from "@inertiajs/svelte";
  import { scale } from "svelte/transition";
  import { onMount } from "svelte";

  export let inquiry, registration, renewal, insurance;

  let formData = {
    id: registration.VehicleDetail.VIN,
    renewalTerm: renewal.renewalTerm || 1,
    affidavit: renewal.affidavit,
    ownerAddr: {
      Address1: registration.OwnerAddrDetail?.Address1,
      Address2: registration.OwnerAddrDetail?.Address2,
      City: registration.OwnerAddrDetail?.City,
      State: registration.OwnerAddrDetail?.State ?? "",
      ZipCode: registration.OwnerAddrDetail?.ZipCode,
      County: registration.OwnerAddrDetail?.County ?? "",
    },
    renewalAddr: {
      Address1: registration.RenewalAddrDetail?.Address1,
      Address2: registration.RenewalAddrDetail?.Address2,
      City: registration.RenewalAddrDetail?.City,
      State: registration.RenewalAddrDetail?.State ?? "",
      ZipCode: registration.RenewalAddrDetail?.ZipCode,
    },
  };

  if (inquiry.no_insurance) {
    formData.insurance = {
      required: 1,
      naic_number: null,
      policy_number: null,
      start_date: null,
      expiration_date: null,
      company_name: null,
    };
  }

  const form = useForm("detailForm", formData);

  let terms = [],
    fees = [];

  function setFees() {
    terms = [];
    let termMap = {
      1: "RenewalDetail",
      2: "TwoYearsRenewalDetail",
      3: "ThreeYearsRenewalDetail",
    };

    if ($form.affidavit) {
      termMap = {
        1: "AffidavitRenewalDetail",
        2: "TwoYearsAffidavitRenewalDetail",
        3: "ThreeYearsAffidavitRenewalDetail",
      };
    }

    for (let termKey in termMap) {
      if (
        registration[termMap[termKey]] &&
        registration[termMap[termKey]].Eligible
      ) {
        terms.push(registration[termMap[termKey]]);
      }
    }

    terms = terms;

    let value = $form.renewalTerm;
    fees = registration[termMap[value]].Fees;
    fees = fees;
  }

  let insuranceErrors = [],
    noInsurance = false,
    ownerAddressErrors = [],
    renewalAddressErrors = [];

  function handleSubmit() {
    $form.clearErrors();
    insuranceErrors = [];
    ownerAddressErrors = [];
    renewalAddressErrors = [];
    $form.post(window.route("renewal.detail.submit"), {
      preserveScroll: true,
      onError: (e) => {
        Object.entries(e).filter((e) => {
          if (e[0].includes("insurance")) {
            insuranceErrors.push(e[1]);
          } else if (e[0].includes("ownerAddr")) {
            ownerAddressErrors.push(e[1]);
          } else if (e[0].includes("renewalAddr")) {
            renewalAddressErrors.push(e[1]);
          }
        });
      },
    });
  }

  onMount(() => {
    setFees();
  });
</script>

<PageHead>
  <svelte:fragment slot="title">Your Renewal</svelte:fragment>
  <svelte:fragment slot="tagline"
    >Please review your information before proceeding. If you have moved, you
    may also update your address.</svelte:fragment
  >
  <Breadcrumb slot="breadcrumb">
    <span slot="home"></span>
    <span slot="search"></span>
    <span slot="detail"></span>
  </Breadcrumb>
  <svelte:fragment slot="extra">
    <Alerts {form} skip={["insurance", "renewalAddr", "ownerAddr"]} />
  </svelte:fragment>
</PageHead>

<div class="row">
  <div class="col-12">
    <form on:submit|preventDefault={handleSubmit}>
      <div class="card">
        <div class="card-header h5">My Registration</div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-4">
              <strong>Information</strong>
              <hr />
              <ul class="list-group list-group-flush">
                <li class="list-group-item d-flex justify-content-between">
                  <div class="text-light-emphasis">Year</div>
                  <div>
                    {registration.VehicleDetail.Year}
                  </div>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <div class="text-light-emphasis">Make</div>
                  <div>
                    {registration.VehicleDetail.Make}
                  </div>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <div class="text-light-emphasis">Model</div>
                  <div>
                    {registration.VehicleDetail.Model}
                  </div>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <div class="text-light-emphasis">Plate Number</div>
                  <div>
                    {registration.PlateNumber}
                  </div>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <div class="text-light-emphasis">New Expiration Date</div>
                  <div>
                    <Time timestamp={registration.RenewalDetail.ExpireDate} />
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-lg-4 justify-content-center d-lg-flex mt-4 mt-lg-0">
              <div class="list-group list-group-flush">
                <strong>Renewal Option</strong>
                <hr />
                {#if terms.length > 0}
                  {#each terms as term}
                    <input
                      type="radio"
                      class="btn-check termYears"
                      value={term.NumberOfRenewalYears}
                      id={"term" + term.NumberOfRenewalYears}
                      bind:group={$form.renewalTerm}
                      on:change={setFees}
                    />
                    <label
                      class:btn-light={$form.renewalTerm !=
                        term.NumberOfRenewalYears}
                      class:bg-primary={$form.renewalTerm ==
                        term.NumberOfRenewalYears}
                      class:border-secondary-subtle={$form.renewalTerm !=
                        term.NumberOfRenewalYears}
                      class:border-primary={$form.renewalTerm ==
                        term.NumberOfRenewalYears}
                      class="btn border-primary bg-opacity-10 border border-2 list-group-item list-group-item-action list-group-item-primarys rounded-1 border-primary mt-1 py-1 ps-2"
                      for={"term" + term.NumberOfRenewalYears}
                    >
                      <div class="p-relative">
                        {#if $form.renewalTerm == term.NumberOfRenewalYears}
                          <i
                            class="bi bi-check-circle-fill text-primary position-absolute"
                            style="left:5"
                            transition:scale={{
                              duration: 500,
                            }}
                          ></i>
                        {/if}
                        <i
                          class="bi bi-circle text-secondary position-absolute"
                          style="left:5"
                        ></i>

                        <div class="ms-4" style="left:0">
                          {term.NumberOfRenewalYears}
                          Year Renewal&nbsp;<Dollar
                            className="fw-bold text-dark ms-4 float-end"
                            value={term.FeeTotal}
                          />
                        </div>
                      </div>
                    </label>
                  {/each}
                {/if}
              </div>
            </div>
            <div class="col-lg-4 mt-4 mt-lg-0">
              <strong>Fee Details</strong>
              <hr />
              <div class="list-group list-group-flush">
                {#if fees && fees.length > 0}
                  {#each fees as fee}
                    <FeeItem
                      name={fee.FeeDescription}
                      bind:amount={fee.FeeAmount}
                    />
                  {/each}
                {:else}
                  <span class="small">There are no fees for this renewal.</span>
                {/if}
              </div>
            </div>
          </div>

          <div class="row text-muted mt-4">
            <div class="col-6">
              <p class="small">
                When a vehicle has been registered for a multi-year period, the
                fee will be paid in advance for the applicable two (2) or three
                (3) year period, however, a decal will be issued for only a one
                (1) year period. <strong>Fees are non-refundable.</strong>
              </p>
            </div>
            <div class="col-6">
              <p class="small">
                Before the decal expires, a decal for the next year will be sent
                from the OMV at no charge if the owner has assessed and paid
                personal property taxes in a timely manner, and has maintained
                liability insurance.
              </p>
            </div>
          </div>
        </div>
      </div>

      {#if inquiry.penalty}
        <div class="card mt-2">
          <div class="card-header h5">
            State of Arkansas Affidavit of Non-Use of a Motor Vehicle
          </div>
          <div class="card-body">
            <Affidavit {form} update={setFees} />
          </div>
        </div>
      {/if}

      {#if inquiry.no_insurance}
        <div class="card mt-2">
          <div class="card-header h5">Insurance</div>
          <div class="card-body">
            <Insurance
              {form}
              {insurance}
              bind:insuranceErrors
              bind:noInsurance
            />
          </div>
        </div>
      {/if}

      <div class="card mt-2">
        <div class="card-header h5">Addresses</div>
        <div class="card-body">
          <p>Have you moved in the last 12 months?</p>

          <div>
            <Address {form} bind:ownerAddressErrors bind:renewalAddressErrors />
          </div>
        </div>
        <div class="card-footer">
          <div class="row g-2 justify-content-between my-1">
            <div class="col-3 d-grid">
              <a
                href={window.route("renewal.search")}
                class="btn btn-secondary"
                use:inertia><i class="bi bi-arrow-left-short"></i> Back</a
              >
            </div>
            <div class="col-3 d-grid">
              <button
                class="btn btn-success"
                on:click|preventDefault={handleSubmit}
                disabled={$form.processing || noInsurance}
                >Next <i class="bi bi-arrow-right-short"></i></button
              >
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
